// extracted by mini-css-extract-plugin
export var anchored = "BranchAndApplicationTeaser-module--anchored--8a1bf";
export var applicationTeaserCard = "BranchAndApplicationTeaser-module--applicationTeaserCard--1d75c";
export var applicationTeaserList = "BranchAndApplicationTeaser-module--applicationTeaserList--adcbe";
export var branchApplicationTeaserButton = "BranchAndApplicationTeaser-module--branchApplicationTeaserButton--901d3";
export var btnFacebook = "BranchAndApplicationTeaser-module--btn-facebook--b20ee";
export var btnLinkedin = "BranchAndApplicationTeaser-module--btn-linkedin--8addd";
export var btnWechat = "BranchAndApplicationTeaser-module--btn-wechat--c7ece";
export var btnXing = "BranchAndApplicationTeaser-module--btn-xing--1d13a";
export var btnYoutube = "BranchAndApplicationTeaser-module--btn-youtube--10d65";
export var fadeIn = "BranchAndApplicationTeaser-module--fade-in--0bce2";
export var fadeOut = "BranchAndApplicationTeaser-module--fade-out--2685e";
export var fullList = "BranchAndApplicationTeaser-module--fullList--82887";
export var icon = "BranchAndApplicationTeaser-module--icon--b21bc";
export var iconText = "BranchAndApplicationTeaser-module--icon-text--39035";
export var imageWrap = "BranchAndApplicationTeaser-module--imageWrap--f134f";
export var leftToRight = "BranchAndApplicationTeaser-module--leftToRight--0cf3c";
export var mail = "BranchAndApplicationTeaser-module--mail--430ea";
export var phone = "BranchAndApplicationTeaser-module--phone--3ea73";
export var printer = "BranchAndApplicationTeaser-module--printer--25733";
export var reverseAnimation = "BranchAndApplicationTeaser-module--reverseAnimation--6382f";
export var showAll = "BranchAndApplicationTeaser-module--showAll--fffd6";
export var showMoreLabel = "BranchAndApplicationTeaser-module--showMoreLabel--842ef";